import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import configLocal from '../configuracao/configLocal';

// const INITIAL_VALUES = {}

export function getList(contid) {
  const request = axiosInstance.get(`/fases/${contid}`);

  return {
    type: 'FASE_FETCHED',
    payload: request,
  };
}

export function getControladorFase() {
  const request = axiosInstance.get(`/fases/mapa/geral`);

  return {
    type: `FASE_FETCHED`,
    payload: request,
  };
}

export function getControladorCoresGT(contId) {
  const request = axiosInstance.get(`/fasesgeral/mapagt/${contId}`);

  return {
    type: `FASEMAP_FETCHED`,
    payload: request,
  };
}

export function getControladorCoresGF(grupoId) {
  const request = axiosInstance.get(`/fasesgeral/mapagf/${+grupoId}`);

  return {
    type: `FASEMAP_FETCHED`,
    payload: request,
  };
}

export function getInicioMapa(grupo) {
  const request = axiosInstance.get(`/fasesgeral/mapa/inicio/${+grupo}`);

  return {
    type: `FASEMAPAINICIO_FETCHED`,
    payload: request,
  };
}

export function getPluviometroMapaData(grupoId) {
  const request = axiosInstance.get(`/pluviometro/mapa/${grupoId || ''}`);

  return {
    type: `PLUVIOMETRO_MAPA_FETCHED`,
    payload: request,
  };
}

export function update(values) {
  const method = values && values.id ? 'put' : 'post';
  return submit(values, method);
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const controlador_id = values.controlador_id;
    const url = method === 'post' ? `/fases/${controlador_id}` : `/fases/${controlador_id}/${id}`;

    axiosInstance[method](url, values)
      .then(resp => {
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      })
      .catch(e => {
        try {
          const errs = (e && e.response && e.response.data && e.response.data.errors) || ['Erro desconhecido'];
          errs.forEach(error => toastr.error('Erro', error));
        } catch (err) {
          toastr.error('Erro', 'Falha ao salvar');
        }
      });
  };
}

export function init() {
  return [getList()];
}
